<template>
    <div class="task-operate">
        <order-handle-dialog
        :isDialog="isDialog"
        :dialogVisible="dialogVisible"
        :handle-close="closeDialog"
        :operate="data.statusResult"
        :task="task"
        title="操作"
        @before-submit="beforeSubmit"
        @on-success="onSuccess"
        @on-error="onError"
        :orderDetail="orderDetail"
        ></order-handle-dialog>
        <el-button v-for="(item,index) in acceptableResult" :key="index" type="primary" size="mini" @click="handleClick(item)">{{formatActionAcceptableResult(item)}}</el-button>
    </div>
</template>
<script>
import { formatActionAcceptableResult } from 'enumeration/lab-order.js'
import orderHandleDialog from 'cps/lab-order/pt-order-handle/dialog'
export default {
  props: {
    // 接收一个task类型对象
    task: {
      type: Object,
      required: true
    },
    // 点击按钮的确认逻辑
    confirm: {
      type: Function
    },
    orderDetail: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components: {
    orderHandleDialog
  },
  data () {
    return {
      dialogVisible: false,
      isDialog: true,
      data: {
        taskId: this.task.id,
        ...this.params
      }
    }
  },
  computed: {
    acceptableResult () {
      return this.task.orderActionData.futureActionAcceptableResults || []
    }
  },
  watch: {
    params: {
      handler () {
        this.data = { ...this.data, ...this.params }
      },
      deep: true
    },
    task: {
      handler () {
        this.data.taskId = this.task.id
      },
      deep: true
    },
    orderDetail: {
      handler (val) {
        console.log('orderDetail', val)
      },
      immediate: true
    }
  },
  methods: {
    formatActionAcceptableResult,
    // showBtn (task) {
    //   // 待处理时显示
    //   return task.status === 'ACTION_REQUIRED'
    // },
    beforeSubmit () {
      this.$emit('before-submit')
    },
    onSuccess (data) {
      this.$emit('on-success', data)
    },
    onError (err) {
      this.$emit('on-error', err)
    },
    closeDialog () {
      this.dialogVisible = false
    },
    showDialog () {
      this.dialogVisible = true
    },
    handleClick (type) {
      if (type === 'SAMPLE_RECOLLECT') {
        this.isDialog = false
      }
      this.data.statusResult = type
      this.showDialog()
    }
  }
}
</script>
<style lang="less">

</style>
